<template>
  <b-modal
    v-model="isVisible"
    title="Политика обработки персональных данных"
    size="lg"
    scrollable
    :hide-footer="true"
    :hide-header-close="false"
  >
    <div class="privacy-content">
      <PrivacyPolicy />
    </div>
  </b-modal>
</template>

<script>
import PrivacyPolicy from './PrivacyPolicy.vue'

export default {
  name: 'PrivacyPolicyModal',
  components: {
    PrivacyPolicy
  },
  props: {
    visible: {
      type: Boolean,
      default: false
    }
  },
  computed: {
    isVisible: {
      get() {
        return this.visible;
      },
      set(value) {
        this.$emit('update:visible', value);
      }
    }
  }
};
</script>

<style scoped>
  .privacy-content {
    max-height: 600px;
    padding-right: 15px;
    overflow-y: auto;
  }
</style>
